<template>
  <div class="invite-line">
    <div class="invite-line-labels">
      <label>Email Address</label>
      <label>First Name</label>
      <label>Last Name</label>
    </div>

    <!--<transition-group name="list" class="invite-line-box" tag="div" ref="inviteBox">-->
    <div class="invite-line-box" ref="inviteBox">
      <div
        v-for="(user, index) in users"
        :key="index"
        class="invite-line-row"
        :class="{ 'error-active': user.error }"
      >
        <div class="invite-line-inputs">
          <input
            type="text"
            placeholder="name@example.com"
            :value="user.email"
            @input="handlers.changeUser(index, 'email', $event)"
          />
          <input
            type="text"
            placeholder="Optional"
            :value="user.firstName"
            @input="handlers.changeUser(index, 'firstName', $event)"
          />
          <input
            type="text"
            placeholder="Optional"
            :value="user.lastName"
            @input="handlers.changeUser(index, 'lastName', $event)"
          />
          <i
            v-show="users.length !== 1"
            class="wticon wticon-cross3"
            @click="handlers.removeUser(index)"
          ></i>
        </div>
        <div v-if="user.error" class="invite-line-error">
          {{ displayErrMsg(user.error) }}
        </div>
      </div>
    </div>
    <!--</transition-group>-->

    <button
      class="invite-more-invitations"
      v-custom-title="maxUsers"
      :disabled="!!maxUsers"
      @click="
        handlers.addUser({});
        scrollTo(true);
      "
    >
      + Add more people
    </button>
  </div>
</template>

<script>
/**
 *  InviteLine
 * */
import app from 'app';

const customTitle = {
  update: function (el, binding) {
    // show title only if maxUsers is true
    el.title = binding.value ? 'up to 20 people' : '';
  },
};

export default {
  props: {
    handlers: {
      type: Object,
      required: true,
    },
  },

  directives: {
    customTitle,
  },

  computed: {
    users: function () {
      return this.handlers.getUsers();
    },

    maxUsers: function () {
      return this.handlers.isMaxUsers;
    },
  },

  beforeMount: function () {
    // add pushExtraEmptyUser here because it should display one empty user line
    // on first entrance without delay or lagging.
    this.pushExtraEmptyUser();
  },

  activated: function () {
    this.pushExtraEmptyUser();

    this.scrollTo();
  },

  watch: {
    users: {
      handler: function (users) {
        const hasErrors = users.some((user) => user.error);

        if (hasErrors) {
          this.scrollTo();
        }
      },
      deep: true,
    },
  },

  methods: {
    displayErrMsg: function (errType) {
      let errMsg = '';

      switch (errType) {
        // front end errors
        case 'email':
          errMsg = 'Please provide a valid email address';
          break;
        case 'duplicateEmail':
          errMsg = 'Email address already in this list';
          break;
        // server side errors
        case 'EMAIL_NOT_IN_SAFE_DOMAIN_LIST':
          errMsg =
            'Only people from your company can be invited. Please contact your Customer Success Manager to update your settings.';
          break;
        case 'EMAIL_NOT_VALID':
          errMsg = 'Please provide a valid email address';
          break;
        case 'EMAIL_IN_USE':
          errMsg = 'Email address already in use';
          break;
        case 'EMAIL_IN_USE_NOT_ACTIVE':
          errMsg =
            'Email address already exists, though not active. Please contact your Customer Success Manager';
          break;
      }

      return errMsg;
    },

    // only will push one empty line
    pushExtraEmptyUser: function () {
      const allUsersFilledAndNoErrors = this.users.every(
        (user) => user.email && !user.error
      );

      if (allUsersFilledAndNoErrors && !this.maxUsers) {
        this.users.push({});
      }
    },

    scrollTo: function (ignoreErrors) {
      app.Vue.nextTick(() => {
        const el = this.$refs.inviteBox;
        const rows = el.querySelectorAll('.invite-line-row');

        if (!rows || !rows.length) {
          return;
        }
        // convert to real array for all Array methods
        const arrRows = Array.from(rows);

        const hasInputFocus = arrRows.some((row) => {
          const allInputsInRow = row.querySelectorAll('input');

          return (
            allInputsInRow[0] === document.activeElement ||
            allInputsInRow[1] === document.activeElement ||
            allInputsInRow[2] === document.activeElement
          );
        });

        // if one of the inputs is active, then don't scroll or add focus
        if (hasInputFocus) {
          return;
        }

        // get the first error active row
        const firstError = arrRows.find((row) =>
          row.classList.contains('error-active')
        );

        // if has errors and ignoreErrors (even with errors, still want to focus on something else)
        if (firstError && !ignoreErrors) {
          el.scrollTop = firstError.offsetTop;
          firstError.querySelector('input').focus();
          return;
        }

        const lastRow = arrRows[arrRows.length - 1];

        el.scrollTop = el.scrollHeight;

        // added set timeout to delay focus for user to notice it
        setTimeout(function () {
          lastRow.querySelector('input').focus();
        }, 500);
      });
    },
  },
};
</script>
